import { useDismissReview } from 'hooks/queries/informalFeedbackRequests/Reviews/useDismissReview'
import {
  InformalFeedbackRequest,
  InformalFeedbackReview,
  InformalFeedbackReviewDismissReason,
} from 'api/clients/InformalFeedbackRequestsClient'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { Button } from 'blaze-ui/Button'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import useResponsiveFunction from 'hooks/useResponsiveFunction'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export interface Props {
  review: InformalFeedbackReview
  request: InformalFeedbackRequest
  isDisabled: boolean
  message: string
}

export const DismissReviewButton = observer(({ review, message, request, isDisabled }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const { rightRailPanelStore, docStore, drawersStore } = useRootStore()
  const { mutate: dismissReview, isLoading: isDismissing } = useDismissReview({
    id: review.id,
    requestId: request.id,
    almanacFileId: request.almanac_file.id,
  })
  const openReviewSubmissionPanel = useResponsiveFunction({
    mobileFunction: () => drawersStore.closeAllDrawers(),
    defaultFunction: () => {
      docStore?.rightRailStore.setActiveTab('AIAssistant')
      rightRailPanelStore.hide()
    },
  })

  const handlePress = () =>
    dismissReview(
      {
        message,
        reason: InformalFeedbackReviewDismissReason.Declined,
      },
      {
        onSuccess: openReviewSubmissionPanel,
        onError: () => {
          showErrorMessageToast('There was an error submitting the review')
        },
      },
    )

  return (
    <Button fullWidth size={isMobile ? 'xl' : 'lg'} isDisabled={isDisabled || isDismissing} onPress={handlePress}>
      Submit Review
    </Button>
  )
})
